<template>
  <div>
    <h1>Deposit Detail</h1>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Type</th>
          <th scope="col">Time</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Mark</td>
          <td>Otto</td>
          <td>@mdo</td>
        </tr>
        <tr>
          <td>Jacob</td>
          <td>Thornton</td>
          <td>@fat</td>
        </tr>
        <tr>
          <td>Jacob</td>
          <td>Larry the Bird</td>
          <td>@twitter</td>
        </tr>
      </tbody>
    </table>
    <Pagination
      v-if="page.total > page.pageSize"
      :total="page.total"
      :pageSize="page.pageSize"
      v-model:currentPage="page.currentPage"
      @change="handlePageChange"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
export default {
  data() {
    return {
      data: [],
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
    };
  },
  components: {
    Pagination,
  },
  methods: {
    handlePageChange(page) {
      console.log(page);
    },
  },
};
</script>

<style></style>
